import React from 'react'
import ReactDOM from 'react-dom'
import './i18n';
import App from './App'

/**
 * This React example is heavily influenced by the default Create React App example. This file only imports the <App>
 * component. Visit the App component for an explanation of how the code in this example works.
 */

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('m-ai-outlander')
)
